import { Component } from '@theme/component';

export class CartRecommendationsComponent extends Component {
  // Use a public property so other components can access the swiper instance
  swiper = null;

  connectedCallback() {
    super.connectedCallback();
    // We wrap in a small timeout to ensure the DOM is fully ready 
    // and Swiper (if loaded via a separate script) is available.
    setTimeout(() => this.initSwiper(), 10);
  }

  disconnectedCallback() {
    this.destroySwiper();
    super.disconnectedCallback();
  }

  destroySwiper() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    // Check if Swiper is loaded on the window
    const SwiperLib = window.Swiper;
    
    if (!SwiperLib || this.swiper) return;

    this.swiper = new SwiperLib(this, {
      slidesPerView: 2,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      freeMode: {
        enabled: true,
        sticky: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        }
      }
    });
  }
}

if (!customElements.get('cart-recommendations-component')) {
  customElements.define('cart-recommendations-component', CartRecommendationsComponent);
}